import { mapGetters, mapMutations } from 'vuex';
import Multiselect from 'vue-multiselect'
import { required, minLength } from 'vuelidate/lib/validators'
import { orderService } from '../../services/OrderService'

export default {
    name: 'OrderType',

    components: {
        Multiselect
    },

    data: () => {
        return {
            loading: true,

            orderType: {},
            propTypes: [
                { text: 'Imobil', value: 0 },
                { text: 'Vehicul', value: 1 },
                { text: 'Alta', value: 2 },
            ],
            periodTypes: [
                { text: 'Luni', value: 0 },
                { text: 'Ani', value: 1 },
                { text: 'Zile', value: 2 },
            ],
            fields: [],
            selectedItem: {},

            dataTypes: [
                { text: 'Text', value: 0 },
                { text: 'Numeric', value: 1 },
                { text: 'Checkbox', value: 2 },
                { text: 'Memo', value: 3 },
            ],
            addCustomFieldMode: false,
        }
    },
    validations: {
        orderType: {
            Description: {
                required,
            }
        }
    },
    computed: {
        ...mapGetters(
            {
                appSettings: 'general/appSettings',
                userSettings: 'general/userSettings',
                order: 'order/order',

            }),
        //
        isValid() {
            return !this.$v.$anyError
        }
    },

    //beforeCreate() {
    //    // load in state
    //    this.$store.dispatch('general/getSettings');
    //},

    created() {

        this.fields = [
            { key: 'Name', label: 'Nume', sortable: true, thStyle: 'width:30%' },
            { key: 'Text', label: 'Text', sortable: true, thStyle: 'width:50%' },
            { key: 'Mandatory', label: 'Obligatoriu', thStyle: 'width:10%' },
            { key: 'DataType', label: 'Tip', thStyle: 'width:10%' },
            { key: 'Action', label: '#',  },
        ];

        this.$store.dispatch('general/getSettings').then(() => {
            this.getOrdetType();
        });

    },

    methods: {

        ...mapMutations(
            {
                setOrderTypeSettingsLoaded: 'general/setOrderTypeSettingsLoaded',
            }),


        addButtonClick: function () {

            // create empty field
            this.selectedItem = {
                Mandatory: false,
                Name: '',
                Text: '',
                DataType: 0
            };
            // 
            this.addCustomFieldMode = true;
            // show modal
            this.$refs.editCustomField.show();
        },

        addCustomField: function () {
            if (this.addCustomFieldMode == true) {
                if (this.orderType.JsonSettings.CustomFields == null) {
                    this.orderType.JsonSettings.CustomFields = [];
                }
                this.orderType.JsonSettings.CustomFields.push(JSON.parse(JSON.stringify(this.selectedItem)));
                this.selectedItem = {};
            }

            this.addCustomFieldMode = false;
        },

        editButtonClick: function (data) {
            // take  a copy of selected item
            this.selectedItem = data.item;
            this.addCustomFieldMode = false;
            // show modal
            this.$refs.editCustomField.show();
        },

        setItemToBeDeleted: function (data) {
            if (data != null) {

                this.selectedItem = data.item;
            }
        },
        deleteButtonClick: function () {
            var model = this;
            this.orderType.JsonSettings.CustomFields = this.orderType.JsonSettings.CustomFields.filter(function (obj) {
                return obj.Name != model.selectedItem.Name;
            });
        },

        validate: function () {
            this.$v.$touch();
            this.$nextTick(() => this.findFirstError());

            return this.isValid;
        },
        chkState: function (val) {
            const field = this.getDescendantProp(this.$v, val);

            return !field.$dirty || !field.$invalid
        },
        //

        addInsurer: function () {

        },

        backButtonClick: function () {
            this.$router.push('/crm/OrderType');
        },

        getOrdetType: function () {

            var model = this;

            var orderPromise = orderService.getOrderType(model.$route.params.id)
                .then(response => {
                    model.orderType = response.data;
                })

            axios.all([orderPromise])
                .then(axios.spread(function () {
                    model.loading = false;
                }));
        },

        saveOrderType: function () {
            var model = this;

            if (!model.validate())
                return;

            // 1 and 2 are seeded as RCA and Locuinta
            if (model.orderType.Id != 1 && model.orderType.Id != 2) {
                model.orderType.UserDefined = true;
            }

            orderService.saveOrderType(model.orderType)
                .then(response => {
                    // if success go to list
                    model.loading = false;
                    this.$router.push('/crm/OrderType');
                });

            //invalidate order settings and reload
            this.setOrderTypeSettingsLoaded(false);
            this.$store.dispatch('general/getOrderTypeSettings');
        }
    },

    watch: {
        "$route.params.id": function (id) {
            this.getOrdetType();
        },

    },
}
